// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ReportPage_pageWrap__1Px2q"};